import { useMutation, useQueryClient } from '@tanstack/react-query';
import { aiAgentApis } from '../../../../../../../shared/apis/ai-agent/apis';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../../shared/types';
import { handleError } from '../../../../../../ui/err/handleError';
import { queries } from '../../../../../../../shared/queries';
import { showSuccessNotification } from '../../../../../../ui/notification';

export default function usePutLinkedModels() {
  const queryClient = useQueryClient();
  return useMutation(aiAgentApis.manual.putLinkedModels, {
    onSuccess: () => {
      showSuccessNotification('연동되었습니다.');
      queryClient.invalidateQueries({ queryKey: queries.aiAgent.aiAgentManuals._def });
      queryClient.invalidateQueries({ queryKey: queries.aiAgent.linkedModels._def });
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
